// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ShortInformation_wrapper__2cBRe","button":"ShortInformation_button__3j-lY","icon":"ShortInformation_icon__1ekwt"};